import S from 'common/service/sanctuary';
import React from 'react';
import { func, string, bool } from 'prop-types';
import { defineMessages, FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import md5 from 'md5';
import Button from 'common/mdc/button';
import Textfield from 'common/mdc/textfield';
import Card from 'common/mdc/card';
import Form, { Error } from 'common/mdc/form';

import { actions, selectors } from 'common/store/auth';

const messages = defineMessages({
  username: {
    id: 'components.login.username',
    defaultMessage: 'Username',
  },
  password: {
    id: 'components.login.password',
    defaultMessage: 'Password',
  },
  login: {
    id: 'components.login.login',
    defaultMessage: 'Login',
  },
  authFailed: {
    id: 'components.login.authFailed',
    defaultMessage: 'Authentication failed',
  },
});

class Login extends React.PureComponent {
  constructor(props) {
    super(props);

    this.login = this.login.bind(this);
  }

  componentDidMount() {
    this.props.init();
  }

  login(e) {
    e.preventDefault();

    this.props.login({
      username: this.usernameInput.value,
      password: md5(this.passwordInput.value + this.props.salt),
    });
  }

  render() {
    const { intl, loading, error } = this.props;

    return (
      <div className="login-background">
        <Card className="login-form" loading={loading}>
          {S.maybeToNullable(S.map(error => (
            <Error>
              {error.result}
            </Error>
          ), error))}
          <Form
            onSubmit={this.login}
            className="login-form-container"
          >
            <Textfield
              inputRef={(input) => { this.usernameInput = input; }}
              disabled={loading}
              name="username"
              label={intl.formatMessage(messages.username)}
              autoFocus
            />
            <Textfield
              inputRef={(input) => { this.passwordInput = input; }}
              disabled={loading}
              name="password"
              type="password"
              label={intl.formatMessage(messages.password)}
            />
            <Button
              type="submit"
              disabled={loading}
              raised
            >
              <FormattedMessage {...messages.login} />
            </Button>
          </Form>
        </Card>
      </div>
    );
  }
}

Login.propTypes = {
  intl: intlShape.isRequired,
  login: func.isRequired,
  loading: bool.isRequired,
  salt: string,
};

Login.defaultProps = {
  salt: undefined,
};

export default connect(
  state => ({
    error: selectors.getErrorMaybe(state),
    loading: selectors.isLoading(state) || selectors.isInitLoading(state),
    salt: selectors.getSalt(state),
  }),
  ({
    init: actions.init,
    login: actions.login,
  }),
)(injectIntl(Login));
